import React from "react";
import MuiAlert from '@material-ui/lab/Alert';

const C1Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default C1Alert;